/**
 * BeLoading Component
 * Buefy의  Loading 상속하여 구현함
 *
 * Ajax 호출시 config에 다음을 설정할 수 있다.
 *  isLoadingBar 로딩바 표시 유무
 *  loadingBarId 특정 로딩바 지정
 */

import axios from 'axios'
import { ADD_LOADING_BAR } from '@/store/LoadingBar.store.js'

/** 로딩바를 표시할지 판단하는 debounce 함수의 WAIT 값 */
const MIN_SHOW_MS = 300

export default {
  name: 'BeLoading',
  // mixin: [Loading], //Mixin을 하지 않아도 잘 됨
  inheritAttrs: false, // 부모 Component에서 지정한 Element 속성을 무시 - vue 파일의 다음 구분 참조(v-bind="$attrs", v-on="$listeners"
  created () {
  },
  mounted () {
    this.addStore()
    this.enableInterceptor()
  },
  beforeDestroy () {
    // 인터셉터 제거
    axios.interceptors.request.eject(this.requestInterceptorId)
    axios.interceptors.response.eject(this.responseInterceptorId)
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    isFullPage: { // Buefy Loadding의 Default 설정
      type: Boolean,
      default: true
    },
    canCancel: { // Buefy Loadding의 Default 설정
      type: Boolean,
      default: false
    },

    // 여기부터는 BeLoading의 고유 기능임
    minShowMs: { // 로딩바 보여지는 최소 시간(ms)
      type: Number,
      default: MIN_SHOW_MS
    },
    isForceCloseMessage: { // 로딩바가 강제로 닫힐때 메시지 표시 유무
      type: Boolean,
      default: true
    },
    forceCloseMessage: { // 로딩바의 강제 닫힐때 표시할 메시지
      type: String,
      default: '응답 대기중인 네트워크 요청 정보를 모두 취소하였습니다.' // 나중에 메시지 처리할 것
    },
    isForceCloseButton: { // 강제 닫기 버튼 표시 유무
      type: Boolean,
      default: true
    },
    isGlobal: { // Global 로딩바 - Global로딩바는 1개만 존재해야 한다.
      type: Boolean,
      default: false
    }
  }, // end props

  computed: {
  },
  methods: {
    /**
     * 로딩바 자신의 ref ID를 찾는다.
     * @returns 자신의 ref ID
     */
    getSelfRef () {
      let selfKey
      for (let key in this.$parent.$refs) {
        if (this.$parent.$refs[key] === this) {
          selfKey = key
          break
        }
      }

      return selfKey
    },
    /** ref값이 설정되어 있다면 Store에 추가 */
    addStore () {
      let selfRefId = this.getSelfRef()

      if (selfRefId !== undefined) {
        let obj = {}
        obj[selfRefId] = this
        this.$store.dispatch(ADD_LOADING_BAR, obj)
      }
    },

    /**
     * Ajax 호출시 Interceptor 할지 판단
     * @returns true : Interceptor 해야 함
     */
    judgeAjaxInterceptor (config) {
      let selfRefId = this.getSelfRef()

      // Ajax 호출시 로딩바를 지정하면 Global 로딩바는 표시하지 않는다.
      if (this.isGlobal && (config?.loadingBarId && config?.loadingBarId !== selfRefId)) return false

      // Ajax호출시 로딩바를 지정하지 않으면 Global 로딩바가 보여진다.
      if (!this.isGlobal && (!selfRefId || config?.loadingBarId !== selfRefId)) return false

      return true
    },
    /**
     * axios의 Request, Response에 대한 Interceptor
     */
    enableInterceptor () {
      // Request에 대한 Interceptor
      this.requestInterceptorId = this.axios.interceptors.request.use((config) => { // 요청 성공 직전에 호출된다.
        if (!this.judgeAjaxInterceptor(config)) return config

        let isLoadingBar = config.isLoadingBar === undefined ? true : config.isLoadingBar
        if (isLoadingBar === true) { // Ajax 호출시 Loading Bar 표시함 옵션이면
          this.increaseCount(config.isLoadingBar) // Ajax 호출시 isLoadingBar를 false로 하면 Loading Bar가 표시되지 않음
        }

        config.cancelToken = this.ajaxCancelTokenSource.token // Ajax 요청을 취소할 수 있게 Token 설정

        return config
      }, (error) => { // 요청 에러 직전에 호출된다.
        return Promise.reject(error)
      })

      // Response에 대한 Interceptor
      this.responseInterceptorId = this.axios.interceptors.response.use((response) => { // 응답 성공 직전에 호출된다.
        if (!this.judgeAjaxInterceptor(response.config)) return response

        this.decreaseCount(response.config?.isLoadingBar) // Ajax 호출시 isLoadingBar를 false로 하면 Loading Bar가 표시되지 않음
        return response
      }, (error) => { // 응답 에러 직전에 호출된다.
        if (!this.judgeAjaxInterceptor(error.config)) return Promise.reject(error)

        this.decreaseCount(error.config?.isLoadingBar) // Ajax 호출시 isLoadingBar를 false로 하면 Loading Bar가 표시되지 않음
        if (axios.isCancel(error)) {
          console.log(error)
        } else {
          alert('실패 - 나중에 실패시 표시하는 컴포넌트 만들 것')
        }

        return Promise.reject(error)
      })
    }, // end enableInterceptor

    /**
     * 요청 카운트 1 증가
     * @param {boolean} isLoadingBar
     */
    increaseCount (isLoadingBar = true) {
      if (isLoadingBar === false) { // Ajax 호출시 Loading Bar 표시 안함 옵션이면
        return
      }

      this.count++
      this.isVisible = true
    },

    /**
     * 요청 카운트 1 감소
     * @param {boolean} isLoadingBar
     */
    decreaseCount (isLoadingBar = true) {
      setTimeout(() => {
        if (isLoadingBar === false) { // Ajax 호출시 Loading Bar 표시 안함 옵션이면
          return
        }

        this.count--
        if (this.count < 0) this.count = 0
      }, 0)
    },
    /**
     * Loading 바를 화면에 표시할지 여부 판단
     */
    judgeVisible () {
      // console.log(`call judgeVisible(), count : ${this.count}}`)
      this.isVisible = this.count > 0
    },

    /**
     * Loading 바를 화면에 표시할지 여부 판단(지연)
     *
     */
    judgeVisibleDebounce () {
      let self = this
      _.debounce(function () {
      // console.log(`call judgeVisibleDebounce(), count : ${this.count}}`)
        self.judgeVisible()
      }, self.minShowMs)()
    },

    /**
     * 강제 닫기 버튼 클릭 이벤트 처리
     */
    onClickForceClose () {
      this.ajaxCancelTokenSource.cancel('canceled network reqeust')
      this.ajaxCancelTokenSource = axios.CancelToken.source() // 닫기 버튼 클릭시 Ajax 요청을 취소하기 위한 Token Source

      this.forceClose()

      if (this.isForceCloseMessage) {
        this.$buefy.toast.open({
          message: this.forceCloseMessage, // Loading Bar를 종료했습니다. 하지만, 서버에 요청한 정보는 계속 응답을 기다립니다.'
          type: 'is-warning',
          duration: 5000,
          queue: false // queue: false => toast가 2개 이상일 때 같은 영역에 덮어쓰지 않고, 최신것이 위에 표시되게 하는 방식
        })
      }
    },

    /** 로딩바를 닫는다. */
    forceClose () {
      this.count = 0
    },

    /** 로딩바를 보이게 한다. */
    show () {
      this.increaseCount(true)
    },

    /** 로딩바를 숨긴다
     * Show() 호출수만큼 hide()를 호출해야 로딩바가 보이지 않게 된다.
     */
    hide () {
      this.decreaseCount(true)
    }
  }, // end methods
  watch: {
    /**
     * count 따라 isVisible을 변경한다.
     *
     * @param {number} newval count 변경 후 값
     * @param {number} oldval count 변경 전 값
     */
    count (newval, oldval) {
      // console.log(`newval : ${newval}`)
      if (newval === 1 && oldval === 0) {
        this.startRequestTime = new Date().getTime()
      }

      let diff = new Date().getTime() - this.startRequestTime
      // console.log(`diff : ${diff}`)

      if (diff > this.minShowMs) { // 이미 500ms 동안 Loading바가 보여졌으면 지연하지 않음
        this.judgeVisible()
      } else { // 최소 500ms 지연
        this.judgeVisibleDebounce()
      }
    }
  },

  data () {
    return {
      count: 0, // 사용자에 대하여 화면에 부여된 권한 - 나중에는 Store 또는 메뉴에서 구해야 함
      startRequestTime: new Date().getTime(), // Request를 여러번 실행 경우 최초 Reqeust 시간
      isVisible: false, // Loading바 화면 표시 여부
      ajaxCancelTokenSource: axios.CancelToken.source(), // 닫기 버튼 클릭시 Ajax 요청을 취소하기 위한 Token Source
      requestInterceptorId: -1, // 요청 인터셉터 ID, 제거용
      responseInterceptorId: -1 // 응답 인터셉터 ID, 제거용
    }
  }
}
